import { HeaderRow, TitleWrap, Title, Right } from './styled'

const ExpandableCardHeader = ({ badge, title, right }) => (
  <HeaderRow>
    <TitleWrap>
      {badge}
      <Title>{title}</Title>
    </TitleWrap>
    {right ? <Right>{right}</Right> : null}
  </HeaderRow>
)

export default ExpandableCardHeader
